import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

import DetailView from "./ViewDetai";
import { CopySettingsDialog } from "./CopySettings";
import { DuplicateLocation } from "./DuplicateLocation";
import AddTaskModal from "../Task/AddTaskModal";
import AddFeed from "../Feed/AddFeedModal";

// Your DropdownMenu component (unchanged)
function DropdownMenu({ anchorRef, open, onClose, children }) {
  const menuRef = useRef();

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !anchorRef.current.contains(e.target)
      ) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open, onClose, anchorRef]);

  const [style, setStyle] = useState({});
  useEffect(() => {
    if (open && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setStyle({
        position: "absolute",
        top: rect.bottom + window.scrollY + 4,
        right: window.innerWidth - rect.right - window.scrollX,
        zIndex: 9999,
        minWidth: rect.width,
      });
    }
  }, [open, anchorRef]);

  if (!open) return null;

  return createPortal(
    <div
      ref={menuRef}
      style={style}
      className="bg-white w-44 rounded shadow-lg py-2"
      dir="ltr"
    >
      {children}
    </div>,
    document.body
  );
}

export default function SplitSettingButton({
  onMenuClick,
  id,
  zipCode,
  locations,
  locationName,
  getLocations,
}) {
  const [open, setOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const btnRef = useRef();
  const arrowRef = useRef();
  const navigate = useNavigate();

  const [showCopySettings, setShowCopySettings] = useState(false);
  const [showDuplicateSettings, setShowDuplicateSettings] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const menuItems = [
    {
      label: "View Details",
      onClick: () => {
        setDetailOpen(true);
      },
    },
    { label: "Copy settings", onClick: () => setShowCopySettings(true) },
    { label: "Duplicate", onClick: () => setShowDuplicateSettings(true) },
    { label: "Schedule", onClick: () => navigate("/schedule") },
    { label: "Approve Timesheets", onClick: () => navigate("/approve") },
    { label: "Message All", onClick: () => setShowMessage(true) },
  ];

  const handleMainClick = () => {
    const first = menuItems[0];
    if (first.onClick) first.onClick();
    if (onMenuClick) onMenuClick(first.label);
  };

  const getToLocationEdit = () => {
    navigate(`/locations/edit/${id}`);
  };

  return (
    <>
      <div className="relative inline-flex">
        {/* Main Button */}
        <button
          ref={btnRef}
          className="px-4 w-32 mr-1 py-1.5 bg-gray-100 text-gray-700 font-semibold rounded-l-md rounded-r-none shadow-sm hover:bg-gray-200 focus:outline-none text-sm"
          onClick={getToLocationEdit}
          type="button"
        >
          Edit Settings
        </button>
        {/* Arrow Button */}
        <button
          ref={arrowRef}
          className="px-2 py-1.5 bg-gray-100 text-gray-700 rounded-r-md rounded-l-none shadow-sm hover:bg-gray-200 focus:outline-none border-l border-gray-200"
          onClick={() => setOpen((v) => !v)}
          type="button"
          aria-label="Show menu"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
        {/* Dropdown Menu */}
        <DropdownMenu
          anchorRef={arrowRef}
          open={open}
          onClose={() => setOpen(false)}
        >
          {menuItems.map((item) => (
            <button
              key={item.label}
              className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-gray-700 text-sm"
              onClick={() => {
                setOpen(false);
                item.onClick();
                if (onMenuClick) onMenuClick(item.label);
              }}
              type="button"
            >
              {item.label}
            </button>
          ))}
        </DropdownMenu>
      </div>

      {/* DetailView Dialog */}
      <DetailView
        open={detailOpen}
        locationName={locationName}
        zipCode={zipCode}
        onClose={() => setDetailOpen(false)}
      />

      {/* Copy Settings */}
      <CopySettingsDialog
        locations={locations}
        open={showCopySettings}
        onClose={() => setShowCopySettings(false)}
      />

      {/* Duplicate Location */}
      <DuplicateLocation
        locationName={locationName}
        getLocations={getLocations}
        id={id}
        open={showDuplicateSettings}
        onClose={() => setShowDuplicateSettings(false)}
      />

      {/* Create Post */}
      <AddFeed isOpen={showMessage} onClose={() => setShowMessage(false)} />
    </>
  );
}
